import { createTrackingUtils } from "..";
import { UIHighlightInfo } from "@flights/types";

const utils = createTrackingUtils({
  name: "flights_merch_toolkit_offer_pinning_v2",
  stages: {},
  defaultStage: 1,
  goals: {
    featured_offer_click: 1,
    next_search_page_navigation: 2,
    featured_info_displayed: 3
  }
});

const trackFeaturedOfferClick = (highlightInfo: UIHighlightInfo) => {
  if (highlightInfo.highlight && highlightInfo.reason === "GENIUS_AIRLINE_FARE_OFFER") {
    utils.goals.featured_offer_click();
  }
};

export default { trackFeaturedOfferClick, ...utils };
